import {connect} from "react-redux";
import {AppBar, Box, Toolbar} from "@mui/material";
import React, {ReactElement, useEffect, useState} from "react";
import {FolderContents} from "./FolderContents";
import makeStyles from "@mui/styles/makeStyles";
import {AssetMetadata} from "./AssetMetadata";
import {IFileSystemContent} from "./content/FileSystemContent";

const useScriptStyles = makeStyles(theme => ({
    assets: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
    },
    folderContents: {
        display: "flex",
        flexGrow: 1,
        height: 0
    }
}));

export type CustomMetadata = {[key: string]: string}

interface IAssetExplorer {
    content: IFileSystemContent
    root?: string
    selected?: string
    tools?: ReactElement | ReactElement []
}
function AssetExplorer({content, root, selected, tools}: IAssetExplorer) {
    const classes = useScriptStyles();
    const [selectedFile, setSelectedFile] = useState<string>();
    const handleSelected = (selected: string) => {
        setSelectedFile(selected);
    };

    useEffect(() => {
        setSelectedFile(selected);
    }, [selected])
    return (
        <Box className={classes.assets}>
            <Box className={classes.folderContents}>
                <FolderContents content={content} onSelected={handleSelected} path={root || content.getRoot()}
                                selected={selected}/>
                {selectedFile && <AssetMetadata content={content} path={selectedFile}/>}
            </Box>
            <AppBar position="relative">
                <Toolbar variant="dense">
                    <Box display="flex" flexGrow={1}>
                        {tools}
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(AssetExplorer);
